import { useTranslation } from 'react-i18next';
import EngagementCarouselSection from './EngagementCarouselSection';

const SkeletonCard = () => (
  <div
    className="
      flex-shrink-0 w-[240px] sm:w-[260px] md:w-[280px]
      rounded-xl border border-gray-200 bg-white overflow-hidden
    "
    aria-hidden="true"
  >
    <div className="aspect-video bg-gray-200 animate-pulse" />
    <div className="p-3 space-y-2">
      <div className="h-3.5 bg-gray-200 rounded animate-pulse w-11/12" />
      <div className="h-3.5 bg-gray-200 rounded animate-pulse w-3/5" />
      <div className="h-3 bg-gray-100 rounded animate-pulse w-2/5 mt-2" />
    </div>
  </div>
);

const EngagementCarouselSkeleton = () => {
  const { t } = useTranslation();
  return (
    <EngagementCarouselSection
      role="status"
      aria-label={t('loading_featured_content_label', 'Loading featured content')}
    >
      <span className="sr-only">{t('loading_featured_content', 'Loading featured content...')}</span>

      <div className="flex items-center justify-between mb-3 sm:mb-4">
        <div className="h-5 sm:h-6 w-36 bg-gray-200 rounded animate-pulse" />
      </div>

      <div className="flex gap-3 overflow-hidden">
        <SkeletonCard />
        <SkeletonCard />
        <SkeletonCard />
        <SkeletonCard />
      </div>
    </EngagementCarouselSection>
  );
};

export default EngagementCarouselSkeleton;
